// extracted by mini-css-extract-plugin
module.exports = {"intro":"TrovaSubitoSection_intro__qK_iH","title":"TrovaSubitoSection_title__w21St","list":"TrovaSubitoSection_list__hAx8f","ctaBox":"TrovaSubitoSection_ctaBox__WGM9L"};